import { z } from 'zod';
import { EMPLOYEE_STATUSES } from '../enums.js';
import { uuid } from './common.js';
/**
 * `GET /org-chart` (FR-MGR-5): every employee who has not left, with their manager as of today
 * (`managerId: null` = top of a tree). The client builds the tree; no salary or sensitive data.
 */
export const orgChartNodeSchema = z.object({
    id: uuid,
    empCode: z.number().int(),
    fullName: z.string(),
    department: z.string().nullable(),
    designation: z.string().nullable(),
    status: z.enum(EMPLOYEE_STATUSES),
    managerId: uuid.nullable(),
    /** Current direct reports who have not left. */
    directReports: z.number().int(),
});
export const orgChartResponseSchema = z.object({ items: z.array(orgChartNodeSchema) });
/**
 * `GET /me/team` (FR-MGR-3, US-05): the caller's reporting tree as of today — direct reports
 * (`depth` 1) and everyone below them, without people who have left (ADR-027). Direct reports'
 * `managerId` is the caller. No salary or sensitive data.
 */
export const teamMemberSchema = orgChartNodeSchema.extend({ depth: z.number().int().min(1) });
export const teamResponseSchema = z.object({ items: z.array(teamMemberSchema) });
//# sourceMappingURL=org.js.map